/**
 * Created by Ivan on 18.01.2023
 */

const EditorFogBalloonView = FogBalloonView.extend({
    ctor: function (balloon) {
        this._super(balloon);

        balloon.moveTo = this.createListener(this.moveTo.bind(this));
        balloon.onDragMove = this.createListener(this.onDragMove.bind(this));
    },

    show: function () {
        this.animation.setAnimation(0, "idle", true);
    },

    onDragMove: function (touch) {
        this.setAlignment(this.parent.convertTouchToNodeSpace(touch));
    },

    moveTo: function (x, y) {
        const position = Map2d.currentMap.getMapView().alignInGrid(x, y);
        this.runAction(new cc.MoveTo(0.05, position.x, position.y));
    }
});